import Controller from '@ember/controller';
import { action } from '@ember/object';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type DeviceModel from 'garaje/models/device';
import type DeviceStatusService from 'garaje/services/device-status-service';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type FlashMessagesService from 'garaje/services/flash-messages';

import type { PropertyDevicesIpadsNewRouteModel } from './route';

export default class PropertyDevicesIpadsNewController extends Controller {
  declare model: PropertyDevicesIpadsNewRouteModel;

  @service('device-status-service') declare deviceStatusService: DeviceStatusService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare flashMessages: FlashMessagesService;
  @service declare router: RouterService;
  @service declare store: Store;

  @action
  reinitializeDevice(): DeviceModel {
    return this.store.createRecord('device', {
      zone: this.model.property,
    });
  }

  @action
  reloadDevicesAndRedirect(): void {
    // deviceStatusService caches each scope's snapshot once loaded, so a device
    // paired after that fetch won't appear in the list until the cache is
    // invalidated. Clear it so the devices route's ensureStatuses re-fetches.
    if (this.featureFlags.isEnabled('property-devices-service-status-api')) {
      this.deviceStatusService.clearStatuses();
    }
    void this.router.refresh('property.devices');
    this.flashMessages.showAndHideFlash('success', 'Successfully added iPad');
    void this.router.transitionTo('property.devices.ipads.index');
  }
}
